export default "__VITE_ASSET__b89ff831__"